import { render, staticRenderFns } from "./MarketplaceNewSKU.vue?vue&type=template&id=034e867a&scoped=true&"
import script from "./MarketplaceNewSKU.vue?vue&type=script&lang=js&"
export * from "./MarketplaceNewSKU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034e867a",
  null
  
)

export default component.exports